import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { ToastContent, getToastContent } from "constants/toasts";
import { selectLanguageLabels, selectMaxLanguagesInFilters } from "store/entities/application-settings/selectors";
import { selectDetectedLanguages } from "store/entities/license";
import { ToastVariant, ToastsActions } from "store/features/toasts";

import { withFilterBase } from "../withFilterBase";

import { createOptions } from "./helpers";

interface IProps {
  filterValues: string[];
  onChange(filterUpdate: { value: string[] | null; name: string }): void;
}

const LanguageFilter: React.FC<IProps> = ({ filterValues, onChange }) => {
  const dispatch = useDispatch();
  const maxLanguagesInFilters = useSelector(selectMaxLanguagesInFilters);
  const detectedLanguages = useSelector(selectDetectedLanguages);
  const languageLabels = useSelector(selectLanguageLabels);
  const options = createOptions(languageLabels, detectedLanguages);

  const selectedLanguages = options.filter(option => filterValues?.includes(option.key));

  const handleChange = (selectedItems: IPickerListItem[] | null): void => {
    if (selectedItems && selectedItems.length > maxLanguagesInFilters) {
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Error,
          content: getToastContent(ToastContent.LANGUAGES_LIMIT_IN_FILTERS_REACHED, { limit: maxLanguagesInFilters }),
        })
      );
      return;
    }

    const isEmpty = !selectedItems || selectedItems.length === 0;

    onChange({
      name: Filter.Language,
      value: isEmpty ? null : selectedItems?.map(item => item.key),
    });
  };
  return (
    <Picker
      id="language-filter"
      onSelect={handleChange}
      type="multi"
      options={options}
      selected={selectedLanguages}
      placeholder="Select"
      openedOnInit
    />
  );
};

export default withFilterBase(LanguageFilter);
